import type { StepProps } from 'aui';
import { Steps } from 'aui';
import SupportIconPropsNode from '../Icon/SupportIconPropsNode';
import type { MdComponentIndexProps } from '../type';
import { mapSpecChildrenFactory } from '../utils/mapSpecChildren';
import { MarkdownStep } from './Step';
import styles from './Steps.module.less';

const mapAcc = mapSpecChildrenFactory(MarkdownStep);
export function MarkdownSteps(props: React.PropsWithChildren<MdComponentIndexProps>) {
  const config = mapAcc(props.children, ({ title, icon, iconColor }, key, child, index) => {
    return {
      key: key ?? String(index),
      title,
      status: 'process',
      icon: (
        <span className={styles.index}>
          {icon ? <SupportIconPropsNode icon={icon} iconColor={iconColor} /> : index + 1}
        </span>
      ),
      description: <div className="markdown-child-root">{child}</div>,
    } as StepProps;
  });

  return (
    <div
      className="w-full"
      data-markdown-component="x-steps-container"
      data-first={props['data-first']}
      data-last={props['data-last']}
    >
      <Steps direction="vertical" items={config} />
    </div>
  );
}

MarkdownSteps.attributes = [] as string[];
